import useOrganization from 'hooks/useOrganization';
import { useEffect } from 'react';
import useLoginStore from 'store/loginStore';

const NavigateHome = ({ homesByRole, replace }) => {
  const currentRole = useLoginStore(s => s.getCurrentRole)();
  const { orgNavigate } = useOrganization();

  useEffect(() => {
    const home = homesByRole[currentRole];
    orgNavigate(home, { replace });
  }, [currentRole]);
}

export default NavigateHome